
import { Component, DestroyRef, ElementRef, inject, Renderer2, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { EventService } from '@common/event.service';
import { IdentityConfigurationService } from '@identity/identity-configuration.service';
import { SharedConstants } from '@shared/constants';

const HIDE_MENU_KEY = 'HIDE_MENU';

@Component({
    selector: 'sas-menu-button',
    standalone: true,
    imports: [],
    templateUrl: './menu-button.component.html',
    styleUrl: './menu-button.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class MenuButtonComponent {
    private eventService = inject(EventService);
    private identityConfigService = inject(IdentityConfigurationService);
    private destroyRef = inject(DestroyRef);

    private RELOAD_MENU_EVENT = SharedConstants.RELOAD_MENU_EVENT;
    hideMenu = this.identityConfigService.getConfiguration(HIDE_MENU_KEY);
    showButton: boolean = false;
    menuId = 'sasMenu';

    constructor(private el: ElementRef, private renderer: Renderer2) {
        this.showButton = this.hideMenu === 'true' ? false : true;
    }

    ngOnInit() {
        this.eventService.getEvent(this.RELOAD_MENU_EVENT)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((ev) => {
            this.hideMenu = this.identityConfigService.getConfiguration(HIDE_MENU_KEY);
            this.showButton = this.hideMenu === 'true' ? false : true;
        });
    }

    handleToggle(ev: Event) {
        this.toggleMenu(this.menuId);
    }

    handleToggleKey(ev: KeyboardEvent): void {
        if (ev.key === " " || ev.key === "Enter" || ev.key === "Spacebar") { // "Spacebar" for IE11 support
            // Prevent the default action to stop scrolling when space is pressed
            ev.preventDefault();
            this.toggleButton(ev.target);
            this.toggleMenu(this.menuId);
        }
    }

    toggleButton(element: EventTarget | null) {
        const elem = element as HTMLElement;
        let btnPressed = (elem.getAttribute("aria-pressed") === 'true');
        elem.setAttribute("aria-pressed", btnPressed ? 'false' : 'true');
    }

    toggleMenu(menuId: string) {
        let menuButton = this.el.nativeElement.querySelector('#menuButton');
        const menu = document.querySelector(`#${this.menuId}`) as HTMLElement;
        //this.renderer.(menu[0], 'inactive');
        this.toggleClass(menu, 'inactive');

        if (!menu.classList.contains('inactive')) {
            this.eventService.emitEvent('setFocusFirstEvent', null);
            menu.setAttribute('aria-expanded', 'true');
            this.renderer.setAttribute(menuButton, 'aria-expanded', 'true');
        }
        else {
            menu.setAttribute('aria-expanded', 'false');
            this.renderer.setAttribute(menuButton, 'aria-expanded', 'false');
            //menuButton.attr('aria-expanded', false)
        }
    }

    toggleClass(elem: Element, className: string) {
        if (elem.classList.contains('inactive')) {
            this.renderer.removeClass(elem, 'inactive');
        }
        else {
            this.renderer.addClass(elem, 'inactive');
        }
    }
}
